import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ManualWarehousingService} from "../../manual-warehousing.service";
import {WarehousingSupplierInterface} from "../../../../../store-management/model/warehousing-supplier-interface.type";
import {AbstractVisbosComponent} from "../../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../../shared/actions";

@Component({
  selector: 'vb-manual-warehousing-data',
  templateUrl: './manual-warehousing-data.component.html',
  styleUrls: ['./manual-warehousing-data.component.css']
})
export class ManualWarehousingDataComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              public warehousingService: ManualWarehousingService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit()
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  onSupplierScanned(supplier: WarehousingSupplierInterface) {

    let consumerType = '';

    switch (supplier.__typename) {
      case 'AdministrationUnit':
        consumerType = 'Standort';
        break;
      case 'Vehicle':
        consumerType = 'Fahrzeug';
        break;
      case 'Supplier':
        consumerType = 'Lieferant';
        break;
      case 'Client':
        consumerType = 'Klient';
        break;
      default:
        consumerType = '';
        break;
    }

  }

  onSupplierChanged(supplier: WarehousingSupplierInterface) {
    this.warehousingService.supplier = supplier;
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-warehousing/components/manual-warehousing-data/manual-warehousing-data.component.ts